<template>
  <div class="container">
    <content-header :data="[{text:'订单一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
            <el-input
              placeholder="订单号/手机号"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-entry">
          <span>下单日期</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="dateChange"
            :picker-options="datePickerOptions">
          </el-date-picker>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            fixed
            prop="orderNumber"
            label="订单号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="orderTotal"
            label="订单金额">
          </el-table-column>
          <el-table-column
            prop="submitDate"
            label="下单日期">
          </el-table-column>
          <el-table-column
            label="订单状态">
            <template slot-scope="scope">
              <span>{{scope.row.orderStatus=='SUBMITTED' ? '已提交' : (scope.row.orderStatus=='CANCELED' ? '已取消' :(scope.row.orderStatus=='PAYMENTED' ? '已支付' :(scope.row.orderStatus=='IN_PROCESS' ? '未提交' : scope.row.orderStatus) ) )}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户ID">
          </el-table-column>
          <el-table-column
            prop="nickName"
            label="客户姓名">
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="手机号">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="cancelHandle(scope)" type="text" size="small" v-if="scope.row.orderStatus != 'CANCELED' ">取消订单</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" v-if="scope.row.orderStatus != 'CANCELED' ">发货确认</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > curSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="curSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import OrderModel from 'models/order'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        curPage: 1,
        curSize: 10,
        total: 0,
        startDate: '',
        endDate: '',
        dateRange: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      this.getObjList()
    },
    methods: {
      pageSizeChange (size) {
        this.curSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.curSize,
          keywords: this.keywords,
          startDate: this.startDate,
          endDate: this.endDate
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        OrderModel.find(_opts).then(res => {
          this.tableData = res.rows
          this.total = res.total
        })
      },
      cancelHandle (item) {
        this.$confirm('确认取消订单？')
          .then(_ => {
            OrderModel.cancel({
              id: item.row.id,
            }).then(() => {
              this.getObjList()
              this.$message({ message: '取消成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '取消失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      searchHandle () {
        this.getObjList()
      },
      dateChange (value) {
        if (value) {
          this.startDate = value[0]
          this.endDate = value[1]
        } else {
          this.startDate = ''
          this.endDate = ''
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
</style>



// WEBPACK FOOTER //
// src/views/Order.vue